<template>
	<Panel :title="'Ficha Técnica'" :panelStyle="'margin-left: 120px'" :icon="'file-alt'" class="ficha-tecnica">
		<div class="panel-block is-block">
			<div class="fotoFicha" :style="'background-image: url(' + user.image +');'"></div>
			<div class="clip"><img src="../assets/img/clip.png" alt=""></div>

			<div class="userInfo">
				<transition name="bounce" mode="out-in">
					<h1 class="title nombreUsuario" :key="user.name">{{ user.name }}</h1>
				</transition>
				<p class="subtitle is-7 statName">Nombre</p>
			</div>

			<div class="columns is-mobile is-multiline">
				<div class="column stat bright bbottom is-4">
					<font-awesome-icon class="statIcon" icon="coins"/>
					<div class="statInfo">
						<transition name="bounce" mode="out-in">
							<div class="statValue" :key="user.puntos">{{ Number(user.puntos).toLocaleString() }}</div>
						</transition>
						<span class="statName">Puntos</span>
					</div>
				</div>
				<div class="column stat bright bbottom is-4">
					<font-awesome-icon class="statIcon" icon="play-circle"/>
					<div class="statInfo">
						<transition name="bounce" mode="out-in">
							<div class="statValue" :key="user.quinielas_jugadas">{{ user.quinielas_jugadas }}</div>
						</transition>
						<span class="statName">Jugadas</span>
					</div>
				</div>
				<div class="column stat bbottom is-4">
					<font-awesome-icon class="statIcon" icon="trophy"/>
					<div class="statInfo">
						<transition name="bounce" mode="out-in">
							<div class="statValue" :key="user.quinielas_ganadas">{{ user.quinielas_ganadas }}</div>
						</transition>
						<span class="statName">Ganadas</span>
					</div>
				</div>

				<div class="column stat bright is-4">
					<font-awesome-icon class="statIcon" icon="check-square"/>
					<div class="statInfo">
						<transition name="bounce" mode="out-in">
							<div class="statValue" :key="user.aciertos">{{ user.aciertos }}</div>
						</transition>
						<span class="statName">Aciertos</span>
					</div>
				</div>
				<div class="column stat bright is-4">
					<font-awesome-icon class="statIcon" icon="chart-pie"/>
					<div class="statInfo">
						<transition name="bounce" mode="out-in">
							<div class="statValue" :key="user.efectividad">{{user.efectividad}} %</div>
						</transition>
						<span class="statName">Efectividad</span>
					</div>
				</div>
				<div class="column stat is-4">
					<font-awesome-icon class="statIcon" icon="futbol"/>
					<div class="statInfo">
						<transition name="bounce" mode="out-in">
							<div class="statValue" :key="user.equipo_id"><img :src="this.$cdn + 'equipos/25x25/' + user.equipo.id  + '.png'" :alt="user.equipo.nombre"></div>
						</transition>
						<span class="statName">Equipo</span>
					</div>
				</div>
			</div>
			
			<router-link to="/seguidores">
				<div class="level is-mobile">
						<div class="level-item has-text-centered">
							<div>
								<div class="heading">Seguidores</div>
								<div class="title is-6">{{ user.seguidores_count }}</div>
							</div>
						</div>
						<div class="level-item has-text-centered">
							<div>
								<div class="heading">Seguidos</div>
								<div class="title is-6">{{user.siguiendo.length}}</div>
							</div>
						</div>
				</div>
			</router-link>
			
			<div v-if="seguirbtn" >
				<SeguirButton :userFollow="user" />
			</div>
		</div>

	</Panel>
</template>

<script>
	import Panel from '@/components/Panel'
	import SeguirButton from '@/components/SeguirButton'
	export default {
		props: {
			user:{
				type: Object,
				required: true
			},
			seguirbtn: {
				type: Boolean,
				default: false 
			}
		},
		components: { Panel, SeguirButton },
		name: 'FichaTecnica',

		data() {
			return {

			};
		},
	};
</script>

<style lang="css" scoped>
.fotoFicha {
	background-position: center center;
	background-size: cover;
	background-repeat: no-repeat;
	border: 5px solid white;
	display: inline-block;
	position: absolute;
	top: 10px;
	left: 10px;
	width: 110px;
	height: 130px;
}
.clip{
	position: absolute;
	left: -29px;
	top: -8px;
}
.userInfo{
	margin-left: 120px;
	margin-bottom: 30px;
	display: block;
}
.nombreUsuario{
	font-size: 1.7em;
	/* white-space: nowrap; */
    overflow: hidden;
    text-overflow: ellipsis;
}
a{
	color: black;
}
</style>
